/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_As_CsvInputs */



/**
* | output |
* | --- |
* | "Export as CSV" |
*
* @param {Export_As_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const export_as_csv = /** @type {((inputs?: Export_As_CsvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_As_CsvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter en CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("Als CSV exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta come CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт в формате CSV")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar como CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出为 CSV 文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CSVとしてエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CSV फ़ाइल के रूप में निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar como CSV")
	return /** @type {LocalizedString} */ ("Export as CSV")
});